export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12032.4f43152b.jpg";